<template>
    <div
        v-if="data"
        class="layout modelsLayout"
        @blur="open = false"
    >
        <div
            class="custom-select item-menu"
            :tabindex="0"
        >
            <!-- SELECTED VIRTUAL-TOUR -->
            <div
                class="selected active"
                :class="{ open: open }"
                @click="open = !open"
                ref="selectTop"
                :style="{ width: selectWidth + 'px' }"
            >
                <span class="icon-holder">
                    <div
                        class="rounded"
                        :style="{ 'backgroundImage': 'url('+ selected.preview +')' }"
                        v-if="selected.preview"
                    />
                    <div
                        class="rounded"
                        :style="{ 'backgroundImage': 'url('+ selected.icon +')' }"
                        v-else-if="selected.icon"
                    />
                </span>
                <span class="nav-text nav-title">
                    {{ selected.text }}
                </span>
                <span
                    class="arrow-icon"
                    :class="{ open: open }"
                >
                    <span class="left-bar"/>
                    <span class="right-bar"/>
                </span>
            </div>
            <!-- /SELECTED VIRTUAL-TOUR -->

            <div
                class="select-variant"
                v-if="data.items"
            >
                <transition name="slidedown">
                    <div
                        v-show="open"
                        class="items"
                        :class="{scroller : data.items.length > 5}"
                        ref="selectBot"
                        :style="{ width: selectWidth + 'px' }"
                    >
                        <div
                            v-for="(item, index) of data.items"
                            :key="index"
                        >
                            <!-- VIRTUAL-TOUR WITHOUT ALTERNATE MODELS-->
                            <div
                                v-if="!item.submenu"
                                class="item subitem"
                                :class="{active: selected.text === item.text}"
                                @click="selectItem(item)"
                            >
                                <span class="icon-holder">
                                    <div
                                        class="rounded rounded__mini"
                                        :style="{ 'backgroundImage': 'url('+ item.preview +')' }"
                                        v-if="item.preview"
                                    />
                                    <div
                                        class="rounded rounded__mini"
                                        :style="{ 'backgroundImage': 'url('+ item.icon +')' }"
                                        v-else-if="item.icon"
                                    />
                                </span>
                                <span class="nav-text habiteo-body-2">
                                    {{ item.text }}
                                </span>
                            </div>
                            <!-- /VIRTUAL-TOUR WITHOUT ALTERNATE MODELS-->

                            <!-- VIRTUAL-TOUR WITH ALTERNATE MODELS-->
                            <div v-else>
                                <div class="item item__title">
                                    <span class="icon-holder">
                                        <div
                                            class="rounded rounded__mini"
                                            :style="{ 'backgroundImage': 'url('+ item.preview +')' }"
                                            v-if="item.preview"
                                        />
                                        <div
                                            class="rounded rounded__mini"
                                            :style="{ 'backgroundImage': 'url('+ item.icon +')' }"
                                            v-else-if="item.icon"
                                        />
                                    </span>
                                    <span class="nav-text h3 font-weight-bold">
                                        {{ item.text }}
                                    </span>
                                </div>
                                <div
                                    class="item pl-8"
                                    v-for="(subitem, si) of item.submenu"
                                    :key="si"
                                    @click="selectItem(item, subitem)"
                                    :class="{active: selected.text === item.text && subitem.active}"
                                >
                                    <span class="nav-text subitem habiteo-body-2">
                                        {{ subitem.text }}
                                    </span>
                                </div>
                            </div>
                            <!-- /VIRTUAL-TOUR WITH ALTERNATE MODELS-->
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'ModelsLayout',
        props: [
            'data'
        ],
        data() {
            return {
                selected: null,
                open: false,
                selectWidth: null
            }
        },
        beforeMount() {
            this.init()
        },
        methods: {
            init() {
                let activeItem = this.data.items.filter(el => el.active)[0];
                if (activeItem.submenu) {
                    let subActiveItem = activeItem.submenu.filter(el => el.active)[0];
                    this.selected = {
                        text : activeItem.text,
                        id : activeItem.id,
                        preview : subActiveItem.preview ? subActiveItem.preview : null,
                        icon : subActiveItem.icon ? subActiveItem.icon : null
                    };
                } else
                    this.selected = activeItem;

                this.$nextTick(() => {
                    this.getMaxWidth();
                });
            },
            getMaxWidth() {
                this.$refs.selectBot.style.display = 'block';
                let topWidth = this.$refs.selectTop.clientWidth;
                let botWidth = this.$refs.selectBot.clientWidth;
                this.$refs.selectBot.style.display = 'none';
                this.selectWidth = topWidth > botWidth ? topWidth : botWidth;
                this.selectWidth = this.selectWidth < 250 ? 250 : this.selectWidth;
            },
            selectItem(item, subitem) {
                this.open = false;
                if (!item.active || !subitem.active) {
                    EventBus.$emit('models_SetActive', item, subitem);
                }
                if (!subitem){
                    this.selected = item;
                }else {
                    this.selected = {
                        text : item.text,
                        id : item.id,
                        preview : subitem.preview ? subitem.preview : null,
                        icon : subitem.icon ? subitem.icon : null
                    }
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/navbarLayout/alternativeMenu/ModelsLayout.vue